export const VideoConstants = {
    GET_VIDEO_BYTOPICID_REQUEST: 'GET_VIDEO_BYTOPICID_REQUEST',
    GET_VIDEO_BYTOPICID_SUCCESS: 'GET_VIDEO_BYTOPICID_SUCCESS',
    GET_VIDEO_BYTOPICID_FAILURE: 'GET_VIDEO_BYTOPICID_FAILURE',

    GET_VIDEO_BYSUBTOPICID_REQUEST: 'GET_VIDEO_BYSUBTOPICID_REQUEST',
    GET_VIDEO_BYSUBTOPICID_SUCCESS: 'GET_VIDEO_BYSUBTOPICID_SUCCESS',
    GET_VIDEO_BYSUBTOPICID_FAILURE: 'GET_VIDEO_BYSUBTOPICID_FAILURE',

    GET_PLAYLIST_VIDEO_REQUEST: 'GET_PLAYLIST_VIDEO_REQUEST',
    GET_PLAYLIST_VIDEO_SUCCESS: 'GET_PLAYLIST_VIDEO_SUCCESS',
    GET_PLAYLIST_VIDEO_FAILURE: 'GET_PLAYLIST_VIDEO_FAILURE',

    GET_FAVORITE_VIDEO_REQUEST: 'GET_FAVORITE_VIDEO_REQUEST',
    GET_FAVORITE_VIDEO_SUCCESS: 'GET_FAVORITE_VIDEO_SUCCESS',
    GET_FAVORITE_VIDEO_FAILURE: 'GET_FAVORITE_VIDEO_FAILURE',

    GET_UNALLOCATED_VIDEO_REQUEST: 'GET_UNALLOCATED_VIDEO_REQUEST',
    GET_UNALLOCATED_VIDEO_SUCCESS: 'GET_UNALLOCATED_VIDEO_SUCCESS',
    GET_UNALLOCATED_VIDEO_FAILURE: 'GET_UNALLOCATED_VIDEO_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/video.constants.js